<template>
  <div class="workspace">
    <div class="flex flex-col">
      <div class="flex flex-col">
        <div class="catering-settings-item">
          <label class="pl-0 vs-input--label"> Minimum catering order time</label>
          <div class="flex flex-row">
          <input v-model="catering_timespan" class="pop-input my-2 py-2" type="text" name="Quantity description" placeholder="Order Time" v-validate="'required'"/>
          <span class="pl-0 vs-input--label hrs"> hours</span>
          </div>
          <span class="text-danger text-sm"
                v-show="errors.has('Order Time')">{{ errors.first('Order Time') }}</span>
        </div>
        <div class="catering-settings-item">
          <label class="pl-0 vs-input--label">Minimum Catering Order Total</label>
          <input v-model="catering_min_total" class="pop-input my-2 py-2" type="number"
                 placeholder="Order Total"
                 name="Order Total" v-validate="'required'"/>
          <span class="text-danger text-sm"
                v-show="errors.has('Order Total')">{{ errors.first('Order Total') }}</span>
        </div>
        <div class="tr-button green-button" @click.prevent="submitUserForm()">Save Settings</div>
      </div>

    </div>
  </div>
</template>
<script>
export default{
  props: {},
  components: {
  },
  data () {
    return {
      catering_timespan: 0,
      catering_min_total: 0
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.AppActiveUser
    },
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }

      }
      return obj
    }
  },
  methods: {
    submitUserForm () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const payload = {
            user_id: this.selectedRestaurant.id,
            property: {
              'Catering-Minimum': this.catering_min_total,
              'Catering-Timespan': this.catering_timespan
            }
          }

          this.$store.dispatch('api/updateUserJWT', payload).then((response) => {
            this.openAlert(response.data.message)
            this.handleData()
            this.$vs.loading.close()
          }).catch(err => {
            console.error(err.message)
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: err.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })
        } else {
          this.openAlert('Please enter valid details')
        }
      })
    },
    openAlert (text) {
      this.$vs.dialog({
        type:'alert',
        color: 'success',
        clickNotClose: true,
        title: 'Confirm',
        acceptText: 'Ok',
        text
      })
    },
    handleData () {
      const { user_property } = this.selectedRestaurant
      this.catering_timespan = user_property['Catering-Timespan']
      this.catering_min_total = user_property['Catering-Minimum']
    }
  },
  watch: {
    '$store.state.api.selectedRestaurant' (val) {
      if (val) {
        this.handleData()
      }
    }
  },
  created () {
  },
  mounted () {
    this.placeService = new window.google.maps.places.PlacesService(this.$refs.result)
    if (this.selectedRestaurant) {
      this.handleData()
    }
  }
}
</script>

<style lang="scss">
.catering-settings-item {
  max-width: 50%;
}
.hrs {
  align-self: end;
  margin: 10px;
}
.pad-12 {
  padding: 0 1.2rem;
}
.img-container > div {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top;
}
.img-container {
  border-radius: 50%;
}

.mobile #profile {
  &.pad-12 {
    padding: 0 !important;
  }
  .vx-col {
    padding: 0 !important;
  }
  .profile-image-wrapper {
    display: flex;
    flex-direction: column;
    text-align: center;

    .vx-col:nth-child(2) {
      .vs-con-input-label {
        text-align: left;
        margin-bottom: 10px;
      }
    }
  }
  .img-container {
    margin: 0 auto !important;
  }
}

</style>
